import axios from "axios";
import { del, get, post, patch,  put } from "./pre_registrations_api_helper";
import * as url from "./pre_registrations_url_helper";





// Get features
export const getPreRegistrations = (filters = {}) => get(url.GET_PRE_REGISTRATIONS, { params: filters });

export const getPreRegistrationByUuid = (uuid) => get(`${url.GET_PRE_REGISTRATION_BY_UUID}/${uuid}`);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewPreRegistration = preRegistration => post(url.ADD_NEW_PRE_REGISTRATION, preRegistration);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updatePreRegistration = preRegistration => patch(`${url.UPDATE_PRE_REGISTRATION}/${preRegistration.id}`,  preRegistration);

export const approvePreRegistration = preRegistration => patch(`${url.APPROVE_PRE_REGISTRATION}/${preRegistration.id}/approve`);
export const rejectPreRegistration = preRegistration => patch(`${url.REJECT_PRE_REGISTRATION}/${preRegistration.id}/reject`);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deletePreRegistration = preRegistration => del(`${url.DELETE_PRE_REGISTRATION}/${preRegistration.id}`);







export {
  //getLoggedInUser,
  
  
};
